import React, { Component } from 'react';
import { Navbar, NavbarBrand, Nav, NavbarToggler, Collapse, NavItem, Jumbotron,
    Button, Modal, ModalHeader, ModalBody,
    Form, FormGroup, Input, Label } from 'reactstrap';
import { NavLink } from 'react-router-dom';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isNavOpen: false,
            isModalOpen: false
        };
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        //this.handleLogin = this.handleLogin.bind(this);
      }

      toggleNav() {
        this.setState({
          isNavOpen: !this.state.isNavOpen
        });
      }

      toggleModal() {
        this.setState({
          isModalOpen: !this.state.isModalOpen
        });
      }

      /*handleLogin(event) {
        this.toggleModal();
        alert("Username: " + this.username.value + " Password: " + this.password.value
            + " Remember: " + this.remember.checked);
        event.preventDefault();

      }*/

    render() {
        return(
            <div>
                <Navbar dark expand="md">
                    <div className="container">
                        <NavbarToggler onClick={this.toggleNav} />
                        <Collapse isOpen={this.state.isNavOpen} navbar>
                            <Nav navbar>
                            <NavItem>
                                <NavLink className="nav-link"  to='/home'><span className="fa fa-home fa-lg"></span> Home</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/aboutus'><span className="fa fa-info fa-lg"></span> About Us</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link"  to='/menu'><span className="fa fa-book fa-lg"></span> Books</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/contactus'><span className="fa fa-address-card fa-lg"></span> Contact Us</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/quiz'><span className="fas fa-chess fa-lg"></span> Quiz</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/reviews'><span className="fas fa-chess fa-lg"></span> Reviews</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/updates'><span className="fas fa-chess fa-lg"></span> Updates</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/combos'><span className="fas fa-chess fa-lg"></span> Combos</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/fischerteaches'><span className="fas fa-chess fa-lg"></span> Fischer Teaches</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/play'><span className="fas fa-chess fa-lg"></span> Play</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/engine'><span className="fas fa-chess fa-lg"></span> Engine</NavLink>
                            </NavItem>
                            </Nav>
                            <Nav className="ml-auto" navbar>
                                <NavItem>
                                    <Button outline onClick={this.toggleModal}><span className="fa fa-sign-in fa-lg"></span>What's New?</Button>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </div>
                </Navbar>
                <Jumbotron>
                    <div className="container">
                        <div className="row row-header">
                            <div className="col-12 col-sm-12">
                                <h1>Welcome to Chess Books 4 Tablets!</h1>
                                <p>Download the free Interactive Chess Books App at the links below! Recently added were books by Fischer, Horowitz and Capablanca.</p>
                                <div>
                                  <a target="_blank" href="https://apps.apple.com/app/interactive-chess-books/id1645731412"><img src="/assets/images/App_Store_Badge.svg" alt="App_Store_Badge"/></a>
                                  <a target="_blank" href="https://play.google.com/store/apps/details?id=com.interactive.chessbook"><img src="/assets/images/google-play-badge.png" alt="google-play-badge"/></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Jumbotron>
                <Modal isOpen={this.state.isModalOpen} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>What's New</ModalHeader>
                    <ModalBody>
                      <p>Added Play and Engine tabs. Click Play tab to play a quick game. Click Engine to analyze with a Chess Engine.</p>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default Header;
